(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class WlAnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-announce-toggle]');
      this.paused = false;

      if (this.toggle) {
        this.toggle.hidden = false;
        this.toggle.addEventListener('click', () => {
          this.paused = !this.paused;
          this.sync();
        });
      }

      // Theme editor: stop the ticker while a message is being edited.
      this.addEventListener('shopify:block:select', () => {
        this.paused = true;
        this.sync();
      });
    }

    sync() {
      this.toggleAttribute('data-paused', this.paused);
      if (!this.toggle) return;
      const label = this.paused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause;
      this.toggle.setAttribute('aria-label', label);
    }
  }

  if (!customElements.get('wl-announcement-bar')) {
    customElements.define('wl-announcement-bar', WlAnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class WlCartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      this.onSubmit = this.onSubmit.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);
      document.addEventListener('submit', this.onSubmit);
      document.addEventListener('click', this.onDocumentClick);

      this.addEventListener('click', (event) => {
        // A click on the dialog element itself is a click on the backdrop.
        if (event.target === this.dialog || event.target.closest('[data-drawer-close]')) {
          this.close();
          return;
        }
        const lineBtn = event.target.closest('[data-line-key]');
        if (lineBtn) this.changeLine(lineBtn.dataset.lineKey, Number(lineBtn.dataset.quantity));
      });
    }

    disconnectedCallback() {
      document.removeEventListener('submit', this.onSubmit);
      document.removeEventListener('click', this.onDocumentClick);
    }

    open() {
      if (!this.dialog.open) this.dialog.showModal();
    }

    close() {
      if (this.dialog.open) this.dialog.close();
    }

    // Header cart icon opens the drawer (except on the cart page itself).
    onDocumentClick(event) {
      if (event.metaKey || event.ctrlKey || event.shiftKey) return;
      const link = event.target.closest('a.wl-header__cart');
      if (!link || document.body.classList.contains('template-cart')) return;
      event.preventDefault();
      this.open();
    }

    // Any add-to-cart form on the site adds in place and opens the drawer.
    onSubmit(event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;
      event.preventDefault();

      const body = new FormData(form);
      body.append('sections', 'cart-drawer');
      const button = form.querySelector('[type="submit"]');
      this.request(this.root + 'cart/add.js', { method: 'POST', body: body }, button);
    }

    changeLine(key, quantity) {
      this.request(this.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: ['cart-drawer'] }),
      });
    }

    request(url, options, button) {
      options.headers = Object.assign({ Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, options.headers);
      this.dialog.setAttribute('aria-busy', 'true');
      if (button) button.setAttribute('aria-disabled', 'true');

      return fetch(url, options)
        .then((response) => response.json().then((data) => ({ ok: response.ok, data: data })))
        .then((result) => {
          if (!result.ok) {
            this.showError(result.data.description || result.data.message);
          } else if (result.data.sections && result.data.sections['cart-drawer']) {
            this.render(result.data.sections['cart-drawer']);
          }
          this.open();
        })
        .catch(() => {
          // Network failure: fall back to the cart page rather than failing silently.
          window.location.href = this.root + 'cart';
        })
        .finally(() => {
          this.dialog.removeAttribute('aria-busy');
          if (button) button.removeAttribute('aria-disabled');
        });
    }

    render(html) {
      const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-drawer-content]');
      const current = this.querySelector('[data-drawer-content]');
      if (!next || !current) return;
      current.innerHTML = next.innerHTML;

      const countEl = current.querySelector('[data-drawer-count]');
      const count = countEl ? Number(countEl.dataset.drawerCount) : 0;
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.classList.toggle('is-empty', count === 0);
      });

      // The control that had focus was replaced; keep focus inside the drawer.
      const closeBtn = current.querySelector('[data-drawer-close]');
      if (this.dialog.open && closeBtn) closeBtn.focus();
    }

    showError(message) {
      const el = this.querySelector('[data-drawer-error]');
      if (!el || !message) return;
      el.textContent = message;
      el.hidden = false;
    }
  }

  if (!customElements.get('wl-cart-drawer')) {
    customElements.define('wl-cart-drawer', WlCartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class WlHeaderMenu extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      if (!this.details) return;

      this.close = () => {
        this.details.open = false;
      };

      this.onDocumentPointerDown = (event) => {
        if (this.details.open && !this.contains(event.target)) this.close();
      };

      this.onKeydown = (event) => {
        if (event.key !== 'Escape' || !this.details.open) return;
        this.close();
        const toggle = this.querySelector('summary');
        if (toggle) toggle.focus();
      };

      document.addEventListener('pointerdown', this.onDocumentPointerDown);
      document.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('pointerdown', this.onDocumentPointerDown);
      document.removeEventListener('keydown', this.onKeydown);
    }
  }

  if (!customElements.get('wl-header-menu')) {
    customElements.define('wl-header-menu', WlHeaderMenu);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  // Hero secondary button: scroll to a section on this page instead of navigating.
  // Without JS (or if the target section isn't on the page) the link works normally.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-scroll-target]');
    if (!link) return;
    const target = document.querySelector(link.dataset.scrollTarget);
    if (!target) return;
    event.preventDefault();
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
// Respect reduced-motion: pause autoplaying section video.
if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  document.querySelectorAll('.wl-how__media video[autoplay]').forEach((video) => {
    video.removeAttribute('autoplay');
    video.setAttribute('controls', '');
    video.pause();
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Gallery: swap main image on thumbnail click (progressive — first image shown by default).
  class WlGallery extends HTMLElement {
    connectedCallback() {
      this.main = this.querySelector('[data-main-image]');
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.select(t)));
    }
    select(t) {
      if (this.main && t.dataset.full) {
        this.main.src = t.dataset.full;
        if (t.dataset.alt) this.main.alt = t.dataset.alt;
      }
      this.thumbs.forEach((x) => x.classList.toggle('is-active', x === t));
    }
  }
  customElements.define('wl-gallery', WlGallery);

  // Variant selection: match radio pills to a variant, update hidden id, price, button, and main image.
  (function () {
    const form = document.getElementById('wl-product-form');
    if (!form) return;
    const dataEl = form.querySelector('[data-variant-data]');
    if (!dataEl) return;
    let variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    const idInput = form.querySelector('[data-variant-id]');
    const priceEl = document.querySelector('[data-price]');
    const addBtn = form.querySelector('[data-add-btn]');
    const addPrice = form.querySelector('[data-add-price]');
    const mainImage = document.querySelector('[data-main-image]');
    const thumbs = Array.from(document.querySelectorAll('[data-thumb]'));
    const gallery = document.querySelector('wl-gallery');
    // Which option (1-based) is the colour; 0 when the product has none.
    const colorPosition = Number(gallery && gallery.dataset.colorPosition) || 0;
    // Arriving from a swatch on a product card (?variant=…) should show that color's photo right away.
    const linkedToVariant = /[?&]variant=/.test(window.location.search);

    function selectedValues() {
      const positions = Array.from(form.querySelectorAll('input[data-option-position]:checked'))
        .sort((a, b) => a.dataset.optionPosition - b.dataset.optionPosition);
      return positions.map((i) => i.value);
    }
    // Show only the selected colour's photos plus the shared ones (no colour in their alt text).
    function filterThumbs(vals) {
      if (!colorPosition) return;
      const color = (vals[colorPosition - 1] || '').toLowerCase();
      thumbs.forEach((t) => {
        t.hidden = Boolean(t.dataset.color) && t.dataset.color !== color;
      });
    }
    function showVariantImage(match) {
      if (!mainImage) return;
      if (match.image) {
        mainImage.src = match.image;
        if (match.image_alt) mainImage.alt = match.image_alt;
        thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.full === match.image));
        return;
      }
      // No photo assigned to this variant: if the photo on show just got hidden, fall back to the first visible one.
      const active = thumbs.find((t) => t.classList.contains('is-active'));
      if (active && !active.hidden) return;
      const first = thumbs.find((t) => !t.hidden);
      if (first) first.click();
    }
    function update(event) {
      const vals = selectedValues();
      const match = variants.find((v) => v.options.length === vals.length && v.options.every((o, i) => o === vals[i]));
      // reflect pill selection styling
      form.querySelectorAll('.wl-pdp__pill').forEach((p) => {
        const input = p.querySelector('input');
        p.classList.toggle('is-selected', input && input.checked);
      });
      filterThumbs(vals);
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = match.price_formatted;
      if (addBtn) {
        addBtn.disabled = !match.available;
        if (match.available) {
          if (addPrice) addPrice.textContent = match.price_formatted;
          else addBtn.textContent = 'Add to cart — ' + match.price_formatted;
        } else {
          addBtn.textContent = 'Sold out';
        }
      }
      // Swap the photo when the shopper picks a color, or on load when the URL names a variant.
      if (event || linkedToVariant) showVariantImage(match);
    }
    form.querySelectorAll('input[data-option-position]').forEach((i) => i.addEventListener('change', update));
    update();
  })();

  // Tabs: click + arrow-key navigation.
  class WlTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = this.tabs.map((t) => document.getElementById(t.getAttribute('aria-controls')));
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.activate(i));
        tab.addEventListener('keydown', (e) => this.onKey(e, i));
      });
    }
    activate(i) {
      this.tabs.forEach((tab, j) => {
        const on = i === j;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        if (this.panels[j]) this.panels[j].hidden = !on;
      });
      this.tabs[i].focus();
    }
    onKey(e, i) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); this.activate((i + 1) % this.tabs.length); }
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); this.activate((i - 1 + this.tabs.length) % this.tabs.length); }
      else if (e.key === 'Home') { e.preventDefault(); this.activate(0); }
      else if (e.key === 'End') { e.preventDefault(); this.activate(this.tabs.length - 1); }
    }
  }
  customElements.define('wl-tabs', WlTabs);

  } catch(e) { console.error(e); }
})();
})();
